import { render, staticRenderFns } from "./invoice-detail.vue?vue&type=template&id=6a22abfc&scoped=true"
import script from "./invoice-detail.vue?vue&type=script&lang=js"
export * from "./invoice-detail.vue?vue&type=script&lang=js"
import style0 from "./invoice-detail.vue?vue&type=style&index=0&id=6a22abfc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a22abfc",
  null
  
)

export default component.exports